// extracted by mini-css-extract-plugin
export default {"container":"ProfileSettings_container__PYE4b","main":"ProfileSettings_main__AlWFK","navigationItem":"ProfileSettings_navigationItem__mba02"};